import React, { useEffect, useState, useCallback } from 'react';
import { useIntl } from 'react-intl-next';

import { Attribution, TransparentErrorBoundary } from '@confluence/error-boundary';
import { useBooleanFeatureFlag } from '@confluence/session-data';
import { Cookies } from '@confluence/cookies';

import { PendoImporter } from './PendoImporter';

export const Pendo = () => {
	const isPendoFfEnabled = useBooleanFeatureFlag('confluence.frontend.pendo.poc');

	const isMauRestrictionFfEnabled = useBooleanFeatureFlag('confluence.frontend.english-only-pendo');
	const [shouldUsePendo, setShouldUsePendo] = useState(false);
	const { locale } = useIntl();
	const onThirdPartyCheckAllowed = useCallback(async () => {
		if (isPendoFfEnabled && (!isMauRestrictionFfEnabled || locale.startsWith('en'))) {
			setShouldUsePendo(true);
		}
	}, [isPendoFfEnabled, isMauRestrictionFfEnabled, locale]);

	const onThirdPartyCheckDenied = useCallback(async () => {
		setShouldUsePendo(false);
	}, []);

	useEffect(() => {
		void Cookies.checkThirdParty('pendo-main', onThirdPartyCheckAllowed, onThirdPartyCheckDenied);
	}, [onThirdPartyCheckAllowed, onThirdPartyCheckDenied]);

	if (!shouldUsePendo) return null;

	return (
		<TransparentErrorBoundary attribution={Attribution.PERMISSIONS_EXPERIENCE}>
			<PendoImporter />
		</TransparentErrorBoundary>
	);
};
